<q9-org-node-sidebar
  *ngIf="impactTreeRootNode.external"
  [orgInfo]="orgInfo$ | async"
  [node]="selectedNode$ | async"
  [refModel]="refModelData$ | async">
  <app-sidebar-header
    [isRefModel]="isRefModel"
    [followLevel]="selectedNode?.followLevel"
    (updateFollow)="toggleFollow(selectedNode)"></app-sidebar-header>
  <div class="delete-btn" *ngIf="showDeleteNodesButton">
    <button
      mat-button
      q9Track="SIDEBAR.DELETE_ALL_NODES"
      color="warn"
      [disabled]="areNodesDeleting$ | async"
      class="q9-btn q9-btn-border q9-btn-warn q9-btn-small"
      (click)="removeMultipleNodes.emit()">
      {{ 'SIDEBAR.DELETE_ALL_NODES' | translate }}
    </button>
  </div>
</q9-org-node-sidebar>

<q9rme-internal-node-sidebar
  *ngIf="!impactTreeRootNode.external"
  [refModel]="refModelData$ | async"
  [orgInfo]="orgInfo$ | async"
  [node]="selectedNode$ | async"></q9rme-internal-node-sidebar>
